import { Calendar, CalendarParams } from '@jupiter/shared';
import { api } from '../api';

export const calendarApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCalendar: builder.query<Calendar, CalendarParams>({
      query: (params) => ({
        url: `calendar`,
        params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetCalendarQuery, useLazyGetCalendarQuery } = calendarApi;
